import React from 'react';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './Title.module.css';

const myaccount = props => {
    return (
        <div className={classes.TitleBox}>
            <img src="/assets/images/myAccountColorIcon.svg" alt="My Account" />
            <p>{applicationTitles.myAccount}</p>
        </div>
    );
};

export default myaccount;
